import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import ButtonModule from '../../component-lib/components/button/button-module';
import { ModalModule } from '../../component-lib/components/modal/modal.module';
import { SlideCardModule } from '../../component-lib/components/slide-card/slide-card.module';
import { ChargingIntroductionComponent } from './introduction.component';
import { ChargingIntroductionMapper } from './introduction.mapper';
import { ChargingIntroductionService } from './introduction.service';
import { DirectivesModule } from '@app/shared/directives/directives.module';

@NgModule({
  declarations: [ChargingIntroductionComponent],
  exports: [ChargingIntroductionComponent],
  imports: [CommonModule, SlideCardModule, TranslateModule, ButtonModule, ModalModule, DirectivesModule],
  providers: [ChargingIntroductionService, ChargingIntroductionMapper],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChargingIntroductionModule {}
